import { atom } from "recoil";      
import { recoilPersist } from 'recoil-persist';
import { GetedNFTMetaType } from "../model/getedNftMetaType";

const { persistAtom } = recoilPersist({
    key:'getedNFTState',
    storage:sessionStorage,
});
// nftjsonからmeta除いて取得した連想配列の状態を,ブラウザ上に永続的(タブが消されない限り)保持する Atoms を作成。
export const getedNFTState = atom<GetedNFTMetaType>({
    key: "getedNFTState",
    default:{
        name:'',
        external_url:'',
        description:'',
        image:'',
        tokenId:'',
        chainId:'',
    },
    effects_UNSTABLE:[persistAtom],
});